import {useEffect, useState} from "react";
import * as React from "react";
import "./UploadReceiptImage.css"
import {css} from "@emotion/css";
import {LinearProgress} from "@mui/material";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {LoansService} from "../../pages/LoinsList/LoansService";
import {HttpClient} from "../../service/httpClient/HttpClient";
import {Buffer} from 'buffer';
import axios from "axios";

const UploadReceiptImage = (
    {
        loanId,
        setImageFile,
        setImageName,
        image,
        setImage,
        hideImageUploadLoading,
        progressImage,
        bufferImage,
        receiptUrl
    }) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()


    const [receiptImageFile, setReceiptImageFile] = useState();


    useEffect(async () => {

        if (typeof receiptUrl !== "undefined" && receiptUrl.length > 0) {

            loading(setLoadingStateDispatch(true))
            try {
                // fetch your file
                const response = await axios.get(receiptUrl, {
                    headers: new HttpClient().prepareUserAccessHeader(token),
                    responseType: "arraybuffer",
                });

                const file = new Blob([response.data], {
                    type: "image/(png|jpeg|jpg)",
                });
                const objectURL = URL.createObjectURL(file);
                setReceiptImageFile(objectURL)

                loading(setLoadingStateDispatch(false))
            } catch (e) {

                loading(setLoadingStateDispatch(false))
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در نمایش رسید پرداخت!"))
            }
        }
    }, [receiptUrl])

    function uploadReceiptImageFile({target: {files}}) {
        if (typeof files[0] !== 'undefined') {
            setImageFile(files[0])
            setImageName(files[0].name)
            setImage(URL.createObjectURL(files[0]))
        }
    }

    // upload-image-end
    return (
        <>
            <input
                type="file"
                id="receiptImageFile"
                hidden={true}
                multiple={true}
                accept="image/png,image/gif,image/jpeg"
                onChange={uploadReceiptImageFile}
            />
            <div className="uploadImageContent"
                 onDragOver={event => {
                     event.stopPropagation();
                     event.preventDefault();
                     event.dataTransfer.dropEffect = 'copy';
                 }}
                 onDrop={event => {
                     event.stopPropagation();
                     event.preventDefault();
                     uploadReceiptImageFile({target: {files: event.dataTransfer.files}})
                 }}
                 id="uploadImageContent">
                <div className="d-flex alignItemsCenter">
                    {
                        image ?
                            <img
                                className={css`
                                  object-fit: fill;
                                  max-width: 25%`}
                                src={image}
                                id={"image"}
                                alt="receiptImageFile"/> :
                            receiptImageFile ?
                                <img
                                    className={css`
                                      object-fit: fill;
                                      max-width: 25%`}
                                    src={receiptImageFile}
                                    id={"image"}
                                    alt="receiptImageFile"/>
                                :
                                <div className="ic-picture"/>
                    }
                    <div className="upload-text-content">
                        <span className="upload-text">آپلود تصویر</span>
                        <span className="drop-down-text">تصویر مورد نظر را انتخاب نمایید.</span>
                    </div>
                </div>
                <button
                    className="btn-confirm"
                    onClick={_ => document.getElementById("receiptImageFile").click()}
                >
                    انتخاب فایل
                </button>
            </div>
            <div className={`${hideImageUploadLoading ? "d-none" : "d-block"}`}>
                <LinearProgress
                    hidden={hideImageUploadLoading}
                    className="w-100 mt-2"
                    variant="buffer"
                    value={progressImage}
                    valueBuffer={bufferImage}
                />
            </div>
        </>
    )
}
export default UploadReceiptImage;